export default __webpack_public_path__ + "static/media/logo.02e019d0.png";